import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

String.prototype.trimChars = function (c) {
    var re = new RegExp("^[" + c + "]+|[" + c + "]+$", "g");
    return this.replace(re,"");
}

/*
let path = window.location.pathname.trimChars('/').split( '/' )
path = path && path[0] ? '/' + path[0] : ''
*/

const API = window.apiUrl + '/v1/admin'
const API_LOGIN_URL = API + '/auth/login'
const API_LOGOUT_URL = API + '/auth/logout'
const API_USER_URL = API +  '/auth/user'
const API_VARIABLE = API + '/initialize'

Vue.use(Vuex)

const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";
const CHECK_SUCCESS = "CHECK_SUCCESS";
const CLIENT_SWITCHED = "CLIENT_SWITCHED"
const WORKSPACE_SWITCHED = "WORKSPACE_SWITCHED"

//document.head.querySelector("[name='X-WEEBOX-CLIENT']").content

export const store = new Vuex.Store({
    state: {
        lang: 'fr',
        isLoggedIn: false,
        scope: localStorage.getItem('scope') | {token:null},
        scopes: null,
        workspace: localStorage.getItem('workspace') | {id:0},
        user: null,
        countriesGrouped: null,
        countries: null,
        currencies: null,
        taxes: null,
        locales: null,
        loaded: false,
        api: API,
        debugApiUrl: '',
        path: '',
        modules: []
    },
    getters: {
        lang: state => {
            return state.lang
        },
        api: state => {
            return state.api
        },
        path: state => {
            return state.path ? state.path.trimChars('/') : 'default'
        },
        modules: state => {
            return state.modules
        },
        debugApiUrl: state => {
            return state.debugApiUrl
        },
        isLoggedIn: state => {
            return state.isLoggedIn
        },
        loaded: state => {
            return state.loaded
        },
        user: state => {
            return state.user
        },
        scope: state => {
            return state.scope
        },
        scopes: state => {
            return state.scopes
        },
        workspace: state => {
            return state.workspace
        },
        countries: state => {
            var countries = {}
            for (let item of state.countries) {
                countries[item.id.toUpperCase()] = item.name
            }
            return countries
        },
        countriesGrouped: state => {
            return {
                options: state.countriesGrouped,
                value: []
            }
        }
    },
    mutations: {
        [CHECK_SUCCESS] (state) {
            state.isLoggedIn = true;
            state.pending = false;
        },
        [LOGIN] (state) {
            state.pending = true;
        },
        [LOGIN_SUCCESS] (state) {
            state.isLoggedIn = true;
            state.pending = false;
        },
        [LOGOUT](state) {
            state.isLoggedIn = false;
        },
        [CLIENT_SWITCHED](state) {
            console.log("CLIENT_SWITCHED", state.scope)
            localStorage.setItem('scope', state.scope.token)
        },
        [WORKSPACE_SWITCHED](state) {
            console.log("WORKSPACE_SWITCHED", state.workspace)
            localStorage.setItem('workspace', state.workspace.id)
        }
    },
    actions: {
        switchScope({ commit }, slug){
            return new Promise((resolve, reject) => {

                this.state.path = slug ? '/' + slug : slug;
                this.state.debugApiUrl = window.apiUrl + this.state.path + '/v1/admin';
                window.axios.defaults.baseURL = this.state.debugApiUrl;

                setTimeout(() => {
                    for (let item of this.state.user.scopes) {
                        if( item.slug == slug ){
                            this.state.scope = item;
                            break;
                        }
                    }
                    commit(CLIENT_SWITCHED);
                    resolve()
                }, 100)
            })
        },
        load({ commit }){
            return new Promise((resolve, reject) => {

                axios.get(API_VARIABLE, {
                    headers: {
                        'Accept': 'application/json',
                        'Accept-Language': 'fr-CH'
                    }
                }).then(response => {
                    var countries = {}
                    for (let item of response.data.countries) {
                        countries[item.id] = item
                    }

                    var countriesGroupedId = []
                    var countriesGrouped = []
                    for (let item of response.data.countries) {
                        if( countriesGroupedId.indexOf(item.region) < 0 && item.region ){
                            countriesGroupedId.push(item.region);
                            var values = []
                            for (let country of response.data.countries) {
                                if( item.region == country.region){
                                    values.push(country)
                                }
                            }
                            countriesGrouped.push({
                                region: item.region,
                                values: values
                            })
                        }
                    }

                    console.log(countriesGrouped)

                    var currencies = {}
                    for (let item of response.data.currencies) {
                        currencies[item.id] = item
                    }

                    var locales = {}
                    for (let item of response.data.locales) {
                        locales[item.id] = item
                    }

                    var taxes = {}
                    for (let item of response.data.taxes) {
                        taxes[item.id] = item
                    }

                    this.state.currencies = response.data.currencies
                    this.state.countriesGrouped = countriesGrouped
                    this.state.countries = response.data.countries
                    this.state.locales = response.data.locales
                    this.state.taxes = response.data.taxes
                    this.state.modules = response.data.modules
                    this.state.loaded = true

                    resolve(response)
                })

            .catch(error => reject(error))

            })
        },
        user({ commit }){
            return new Promise((resolve, reject) => {

                var config = {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        'Accept':  'application/json'
                    }
                };

                axios.get(API_USER_URL, config).then(response => {
                    console.log("user", response.data)
                    this.state.user = response.data
                    for (let item of response.data.scopes) {
                        if( item.token == localStorage.getItem('scope') ){
                            this.state.scope = item;
                            break;
                        }
                    }

                    var scopes = {}
                    for (let item of response.data.scopes) {
                        scopes[item.id] = {
                            id: item.id,
                            name: item.name,
                            slug: item.slug,
                            color: item.color,
                            is_ttc: item.is_ttc,
                            children: item.children
                        }
                    }
                    this.state.scopes = scopes;

                    commit(CHECK_SUCCESS);
                    resolve(response)
                })

            .catch(error => reject(error))

            })
        },
        login({ commit }, creds){

            localStorage.removeItem('token')
            localStorage.removeItem('workspace')
            localStorage.removeItem('scope')

            commit(LOGIN); // show spinner
            return new Promise((resolve, reject) => {
                    axios.post(API_LOGIN_URL, creds)
                    .then(response => {
                        console.log(response.data)

                        var scopes = {}
                        for (let item of response.data.user.scopes) {
                            scopes[item.id] = {
                                id: item.id,
                                name: item.name,
                                slug: item.slug,
                                color: item.color,
                                children: item.children
                            }
                        }
                        this.state.scopes = scopes;

                        localStorage.setItem('token', response.data.token)
                        this.state.user = response.data.user
                        commit(LOGIN_SUCCESS);
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        logout({ commit }) {
            localStorage.removeItem("token")
            localStorage.removeItem('workspace')
            localStorage.removeItem('scope')
            this.state.user = null
            this.state.isLoggedIn = false
            commit(LOGOUT);
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js